import React from "react";
import Notif from "../../components/admin/notif/notif";

const NotifPage = () => {
    return (
        <div>
            <Notif />
        </div>
    );
}

export default NotifPage;